import { Interpolation, Theme } from '@emotion/react';
import { ReactElement } from 'react';
import { FixedSizeGrid } from 'react-window';

interface IProps<T> {
  items: T[];
  itemHeight: number;
  crossAxesCount: number;
  itemBuilder: (element: T) => ReactElement;
}

export const ACDLVirtualGrid = <T,>(props: IProps<T>): ReactElement => {
  const { crossAxesCount, items, itemHeight, itemBuilder } = props;
  const rowCount = Math.ceil(items.length / crossAxesCount);
  const height = Math.max(Math.min(itemHeight * rowCount, 600), 250);
  const width = 500;
  const itemWidth = (width - 20) / crossAxesCount;

  return (
    <FixedSizeGrid
      height={height}
      width={width}
      columnWidth={itemWidth}
      rowHeight={itemHeight}
      columnCount={crossAxesCount}
      rowCount={rowCount}
    >
      {({ columnIndex, rowIndex, style }): ReactElement => {
        const index = rowIndex * crossAxesCount + columnIndex;
        if (index < items.length) {
          return <div css={style as Interpolation<Theme>}>{itemBuilder(items[index])}</div>;
        }
        return <div />;
      }}
    </FixedSizeGrid>
  );
};
